import { isEmotionPropValid } from './isEmotionPropValid'

export const isLibPropValid = isEmotionPropValid('variant')
